/* unplugin-vue-components disabled */import script from "./BaseData.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseData.vue?vue&type=script&setup=true&lang=js"

import "./BaseData.vue?vue&type=style&index=0&id=56d8ed44&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56d8ed44"]])

export default __exports__